// extracted by mini-css-extract-plugin
export var dashboard = "dashboard_ni26UFEG8ooVkeDpY2sQ";
export var dashboardBg = "dashboard-bg_YAc1Ouo1EAYzJnX8p9A2";
export var dashboardFooter = "dashboard-footer_P4FFFZKsJbGo8xwF50w_";
export var dashboardTitle = "dashboard-title_rV9sOvghay0FwDS0TmIm";
export var navCard = "nav-card_htdtL6Mi0vHLaQzA9dae";
export var navCardIcon = "nav-card-icon_oF4i0ka1rUroWUHb8I0w";
export var navGrid = "nav-grid_JMWKHjlBL_gjAOnLhZzu";
export var waveOne = "wave-one_tWL2QrxGM6lWVBgxn3I8";
export var waveSvg = "wave-svg_nftKpRzoa0W5bM3PXrBP";
export var waveThree = "wave-three_EeHEO5Rt1N7fyYqAcDF_";
export var waveTwo = "wave-two_o_of7A8BQerFHr_Ag_W2";